<template>
  <v-container>
    <v-row
      justify="center"
      class="main--text">
      <v-col md="8">
        <v-card>
          <v-toolbar
            color="primary"
            dark>
            <v-toolbar-title
              class="font-weight-bold pb-0">
              教師　新規情報登録フォーム
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text
            class="font-weight-bold red--text"
            v-show="errorMessage">
            {{ errorMessage }}
          </v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="familyName"
                    label="姓"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="familyName"
                    data-vv-as="名前"
                    required
                    :error-messages="errors.collect('familyName')"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    v-model="personalName"
                    label="名"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="personalName"
                    data-vv-as="名前"
                    required
                    :error-messages="errors.collect('personalName')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="flatFamilyName"
                    label="セイ"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="flatFamilyName"
                    data-vv-as="名前"
                    required
                    :error-messages="errors.collect('flatFamilyName')"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    v-model="flatPersonalName"
                    label="メイ"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="flatPersonalName"
                    data-vv-as="名前"
                    required
                    :error-messages="errors.collect('flatPersonalName')"
                   >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-col>
                <v-radio-group
                  v-model="sex"
                  row
                  required
                  v-validate="'required'"
                  data-vv-name="sex"
                  data-vv-as="性別"
                  :error-messages="errors.collect('sex')"
                >
                  <v-radio
                    label="男性"
                    value="male">
                  </v-radio>
                  <v-radio
                    label="女性"
                    value="female">
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="phone"
                  label="電話番号(ハイフン無し)"
                  type="text"
                  required
                  v-validate="'required|numeric'"
                  data-vv-name="phone"
                  data-vv-as="電話番号"
                  :error-messages="errors.collect('phone')"
                >
                </v-text-field>
              </v-col>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="postalCode"
                    label="郵便番号(ハイフンなし７ケタ)"
                    type="text"
                    required
                    v-validate="'required|numeric'"
                    data-vv-name="postalCode"
                    data-vv-as="郵便番号"
                    :error-messages="errors.collect('postalCode')"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-btn
                    depressed
                    rounded
                    outlinedd
                    color="primary"
                    @click="searchAddress">
                    住所検索
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="prefecture"
                    label="都道府県"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="prefecture"
                    data-vv-as="都道府県"
                    required
                    :error-messages="errors.collect('prefecture')"
                    >
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    v-model="municipality"
                    label="市区町村"
                    type="text"
                    v-validate="'required'"
                    data-vv-name="municipality"
                    data-vv-as="市区町村"
                    required
                    :error-messages="errors.collect('municipality')"
                    >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="subAddress"
                    label="下位住所（丁目番地以下）"
                    type="text"
                    required
                    v-validate="'required'"
                    data-vv-name="subAddress"
                    data-vv-as="住所"
                    :error-messages="errors.collect('subAddress')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-col md="4">
                <BirthdayPicker
                  v-model="birthday"
                />
              </v-col>
              <v-col md="4">
                <v-autocomplete
                  v-model="university"
                  :items="universities"
                  label="大学"
                  item-text="name"
                  required
                  v-validate="'required'"
                  data-vv-name="university"
                  data-vv-as="大学名"
                  :error-messages="errors.collect('university')"
                >
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-radio-group
                  v-model="inUniversity"
                  row
                  required
                  v-validate="'required'"
                  data-vv-name="inUniversity"
                  :error-messages="errors.collect('inUniversity')"
                >
                  <v-radio
                    label="在学"
                    :value="true">
                  </v-radio>
                  <v-radio
                    label="既卒"
                    :value="false">
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model="nearestStation"
                  label="最寄り駅 (例)渋谷駅"
                  type="text"
                  required
                  v-validate="'required'"
                  data-vv-name="nearestStation"
                  data-vv-as="最寄り駅"
                  :error-messages="errors.collect('nearestStation')"
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-col
                  class="font-weight-bold">
                  指導可能時間帯
                </v-col>
                <div
                  v-for="(availableSchedule, index) in availableSchedules"
                  :key="index"
                >
                  <ScheduleSelector
                    v-model="availableSchedules[index]"
                    :items="availableSchedules"
                    @addNewLine="addNewLine"
                    @deleteLine="deleteLine(index)"
                  />
                </div>
              </v-col>
              <v-col md="4">
                <v-autocomplete
                  v-model="expectedWage"
                  :items="wages"
                  label="希望報酬額(1時間あたり)"
                  item-text="name"
                  required
                  v-validate="'required'"
                  data-vv-name="wages"
                  data-vv-as="希望報酬額"
                  :error-messages="errors.collect('wages')"
                >
                </v-autocomplete>
              </v-col>
              <v-col xs="12">
                <v-textarea
                  v-model="selfIntroduction"
                  outlined
                  name="input-7-4"
                  label="自己PR等"
                  value=""
                  required
                  v-validate="'required'"
                  data-vv-name="selfIntroduction"
                  data-vv-as="自己PR等"
                  :error-messages="errors.collect('selfIntroduction')"
                >
                </v-textarea>
              </v-col>
              <v-row justify="end">
                <v-btn
                  @click="putItem()"
                  color="primary"
                  class="ma-4"
                >登録
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TeacherRepository } from '@/repository/TeacherRepository.js'
import  ScheduleSelector  from '@/components/molecules/ScheduleSelector.vue'
import BirthdayPicker from '@/components/molecules/BirthdayPicker.vue'
import { firestore } from '@/repository/client/firestore.js'
import { universities } from '@/models/University.js'
import { app } from '@/core/firebase.js'
import { getAddress } from "@/core/geocoding"

export default {
  name: 'TeachersProfileForm',
  components:{
    ScheduleSelector: ScheduleSelector,
    BirthdayPicker: BirthdayPicker
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      birthdayMenu: false,
      personalName: '',
      familyName: '',
      sex: '',
      phone: '',
      postalCode: '',
      prefecture: '',
      municipality: '',
      subAddress: '',
      birthday: new Date(2000, 0, 1),
      flatFamilyName: '',
      flatPersonalName: '',
      availableSchedules: [{}],
      university: null,
      inUniversity: true,
      nearestStation: '',
      expectedWage: '',
      selfIntroduction: '',
      universities: universities,
      errorMessage: "",
    }
  },
  methods: {
    async putItem() {
      const result = await this.$validator.validateAll()
      const repo = new TeacherRepository(firestore)
      if (result) {
        const uid = app.auth().currentUser.uid
        const currentUser =  app.auth().currentUser
        const teacher = await repo.put({
          uuid: uid,
          personalName: this.personalName,
          familyName: this.familyName,
          flatPersonalName: this.flatPersonalName,
          flatFamilyName: this.flatFamilyName,
          email: currentUser.email,
          postalCode: this.postalCode,
          prefecture: this.prefecture,
          municipality: this.municipality,
          subAddress: this.subAddress,
          birthday: this.birthday,
          sex: this.sex,
          phone: this.phone,
          availableSchedules: this.availableSchedules,
          expectedWage: this.expectedWage,
          nearestStation: this.nearestStation,
          university: this.university,
          inUniversity: this.inUniversity,
          selfIntroduction: this.selfIntroduction
        }
        )
        this.$store.commit('loginAsTeacher', teacher)
        this.$router.push(`/teacher/${uid}/profile`)
      }
    },
    addNewLine() {
      // console.log("schedule:" + this.availableSchedules)
      this.availableSchedules.push({})
    },
    deleteLine(index) {
      if (this.availableSchedules.length > 1) {
        this.availableSchedules.splice(index, 1)
      }
    },
    async searchAddress() {
      try {
        const result = await getAddress(this.postalCode)
        this.prefecture = result.prefecture
        this.municipality = result.municipality
      } catch(e) {
        if (e.message === "Cannot specifiy the address.") {
          this.errorMessage = "住所が見つかりません。"
        }
      }
    }
  },
  computed: {
    wages() {
      var range = new Array()
      for (let i = 3; i <= 20; i++) {
        range.push(i * 500)
      }
      return range
    },
  },
}
</script>

